export var PackageItineraryState;
(function (PackageItineraryState) {
    PackageItineraryState["Future"] = "Future";
    PackageItineraryState["Present"] = "Present";
    PackageItineraryState["Past"] = "Past";
    PackageItineraryState["Canceled"] = "Canceled";
})(PackageItineraryState || (PackageItineraryState = {}));
//# sourceMappingURL=packageItinerary.js.map